import script from "./TextEditor2.vue?vue&type=script&setup=true&lang=js"
export * from "./TextEditor2.vue?vue&type=script&setup=true&lang=js"

import "./TextEditor2.vue?vue&type=style&index=0&id=30743517&lang=css"

const __exports__ = script;

export default __exports__